import { render, staticRenderFns } from "./CustomFormTypeList.vue?vue&type=template&id=672d7d32"
import script from "./CustomFormTypeList.js?vue&type=script&lang=js&external"
export * from "./CustomFormTypeList.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormTypeList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports